<template>
    <link-input :prefixIcon="!!searchIcon?'link-icon-search':null" :placeholder="$t('LinkFilter.searchKey')+'...'" @enter="lv_enter" @click-suffix-icon="lv_clear" ref="input" :value="dynamicFilter.value.val"/>
</template>

<script>
    import {DynamicFilterMixin} from "../link-dynamic-filter";

    export default {
        name: "link-dynamic-filter-input",
        mixins: [DynamicFilterMixin],
        methods: {
            async getValue() {
                let val = this.$refs.input.$refs.input.value
                if (val != null && val !== '') val = val.trim()
                this.dynamicFilter.value = {val}
                if (val !== this.$refs.input.$refs.input.value) this.$nextTick(() => this.$refs.input.currentValue = val)
            },


            lv_enter() {
                return this.confirm()
            },
            lv_clear() {
                return this.confirm()
            },
        }
    }
</script>

<style lang="scss">

</style>